module.exports = __webpack_public_path__ + "img/logotipo-notazz.3859b555.svg";